import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useAuth } from "../../context/AuthContext";

const Footer = () => {
  const theme = useTheme();
  const { user } = useAuth();
  return (
    <Box sx={{ 
      py: 8,
      bgcolor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.divider}`
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 3 }}>
              <img 
                src="https://seethakalyanavaibhogame.com/images/skvlogo1.jpg"
                alt="Logo"
                style={{ 
                  height: '60px', 
                  width: '60px',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
            </Box>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 700,
                color: theme.palette.primary.main,
                mb: 2
              }}
            >
              Seetha Kalyana Vaibhogame
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: theme.palette.text.secondary,
                lineHeight: 1.6
              }}
            >
              Connecting hearts and building families through our trusted matrimonial platform. 
              Your journey to finding true love starts here.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 700,
                color: theme.palette.primary.main,
                mb: 3
              }}
            >
              Quick Links
            </Typography>
            <Box component="ul" sx={{ pl: 0, listStyle: 'none' }}>
              <Box component="li" sx={{ mb: 2 }}>
                <Button
                  component={Link}
                  to="/about"
                  sx={{ 
                    color: theme.palette.text.secondary,
                    textTransform: 'none',
                    p: 0,
                    minWidth: 'auto',
                    justifyContent: 'flex-start',
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  About Us
                </Button>
              </Box>
              <Box component="li" sx={{ mb: 2 }}>
                <Button
                  component={Link}
                  to="/privacy-policy"
                  sx={{ 
                    color: theme.palette.text.secondary,
                    textTransform: 'none',
                    p: 0,
                    minWidth: 'auto',
                    justifyContent: 'flex-start',
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  Privacy Policy
                </Button>
              </Box>
              <Box component="li" sx={{ mb: 2 }}>
                <Button
                  component={Link}
                  to="/shipping-delivery"
                  sx={{ 
                    color: theme.palette.text.secondary,
                    textTransform: 'none',
                    p: 0,
                    minWidth: 'auto',
                    justifyContent: 'flex-start',
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  Shipping & Delivery
                </Button>
              </Box>
              <Box component="li" sx={{ mb: 2 }}>
                <Button
                  component={Link}
                  to="/cancellation-refund"
                  sx={{ 
                    color: theme.palette.text.secondary,
                    textTransform: 'none',
                    p: 0,
                    minWidth: 'auto',
                    justifyContent: 'flex-start',
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  Cancellation & Refund
                </Button>
              </Box>
              <Box component="li" sx={{ mb: 2 }}>
                <Button
                  component={Link}
                  to="/terms-and-conditions"
                  sx={{ 
                    color: theme.palette.text.secondary,
                    textTransform: 'none',
                    p: 0,
                    minWidth: 'auto',
                    justifyContent: 'flex-start',
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  Terms & Conditions
                </Button>
              </Box>
              <Box component="li" sx={{ mb: 2 }}>
              {user && (

                <Button
                  component={Link}
                  to="/unregister"
                  sx={{ 
                    color: theme.palette.text.secondary,
                    textTransform: 'none',
                    p: 0,
                    minWidth: 'auto',
                    justifyContent: 'flex-start',
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  Unsubscribe
                </Button>
              )}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 700,
                color: theme.palette.primary.main,
                mb: 3
              }}
            >
              Contact Information
            </Typography>
            <Box sx={{ mb: 3 }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: theme.palette.text.secondary,
                  mb: 1
                }}
              >
                Email: info@seethakalyanavaibhogame.com 
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: theme.palette.text.secondary,
                  mb: 1
                }}
              >
                Phone: 818-686-6869
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: theme.palette.text.secondary
                }}
              >
                Available 24/7
              </Typography>
            </Box>
            <Button
              component={Link}
              to="/contact"
              variant="outlined"
              size="small"
              sx={{
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
                '&:hover': {
                  borderColor: theme.palette.primary.dark,
                  bgcolor: theme.palette.primary.main,
                  color: 'white'
                }
              }}
            >
              Contact Us
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ 
          mt: 6, 
          pt: 3, 
          borderTop: `1px solid ${theme.palette.divider}`,
          textAlign: 'center'
        }}>
          <Typography 
            variant="body2" 
            sx={{ 
              color: theme.palette.text.secondary
            }}
          >
            © 2024 Seetha Kalyana Vaibhogame. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 